import {AppSettings} from '../constants';
import Jwt from 'helper/interceptors';
import { ObjToParam, MapResponse } from 'helper/helper-api';
import removeDiacritics from 'helper/remove-diacritics';
import { v4 as uuidv4 } from 'uuid';
import S3 from 'aws-sdk/clients/s3';
import { config, Credentials } from 'aws-sdk/lib/core';

export const getSelectListItemAccounts = (params) => {

  return Jwt(AppSettings.SITE_ONE_SERVICE_URI, false).get(`/api/accounts/select-list-item-accounts?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListItemTrade = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL, false).get(`/apiv1/trades/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListItemToRepair = (params) => {
  return Jwt(AppSettings.GLOBAL_API_URL, false).get(`/apiv1/itemrepairs/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListItemToRepairByTradeId = (params) => {

  return Jwt(AppSettings.GLOBAL_API_URL, false).get(`/apiv1/itemrepairs/select-list-items/byTradeId?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListItemProblemByItemRepairId = (params) => {

  return Jwt(AppSettings.GLOBAL_API_URL, false).get(`/apiv1/problems/select-list-items/byItemRepairId?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListRegion = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/region/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListMarket = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/market/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListMarketByRegionId = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/market/select-list-items/by-region?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListPhasesByProjectId = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false, {headers: [{key: 'Key', value: params.projectId}]}).get(`/api/phases/select-list-items/by-project?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListModelsByProjectId = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false, {headers: [{key: 'Key', value: params.projectId}]}).get(`/api/models/select-list-items/by-project?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListRooms = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/rooms/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListSubcontractor = (params) => {

  return Jwt(AppSettings.GLOBAL_API_URL, false).get(`/apiv1/subcontractors/select-list-subcontractors?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListProjects = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/projects/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListRequestTypes = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/request-types/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListWorkOrderTypes = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/workorder-types/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListLots = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/lots/select-list-items/by-project?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListInsurances = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/select-lists/insurance-policies?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const setupCommonAWS = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).post('/api/aws/s3/credentials', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const uploadCommonToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const fileName = removeDiacritics(params.file.name);
  const enFileName = uuidv4() + '.' + fileName.split('.').pop();
  const s3 = new S3({ region: params.config.region });

  const payload = {
    ACL: 'public-read',
    Body: params.file,
    Bucket: params.config.bucket,
    ContentType: params.file.type,
    ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${enFileName}`
  };
  let upload = s3.upload(payload);
  let isDelete = false;
  upload.send((error, data) => {
    if (data) {
      /**
       * callback delete file after upload file success
       */
      if (isDelete) {
        const bucketInstance = new S3({ region: params.config.region });
        bucketInstance.deleteObject({
          Bucket: params.config.bucket,
          Key: `${params.config.path}/${enFileName}`}, (err, res) => {
          if (res) {
            if (process.env.NODE_ENV === 'development') {
              console.log('File deleted successfully');
            }
          }
          else {
            if (process.env.NODE_ENV === 'development') {
              console.log('Check if you have sufficient permissions : ' + err);
            }
          }});
      } else {
        callback(true, {data});
      }
    }
    /**
     * callback when upload file success
     */
    else {
      callback(false, {data});
    }
  });
  /**
   * callback when user cancel uploading file
   */
  const cancelUpload = () => {
    setTimeout(upload.abort.bind(upload), 100);
  };
  const deleteFile = () => {
    isDelete = true;
  };
  if (params.file.size > 1024 * 1024 * 5) {
    callback('pending', {cancelUpload, uploadId: params.file.uploadId, fileName});
  } else {
    callback('delete', {deleteFile, uploadId: params.file.uploadId, fileName});
  }
};

export const uploadSignatureToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  // const fileName = removeDiacritics(params.file.name);
  const fileName = uuidv4() + '.png';
  const s3 = new S3({ region: params.config.region });
  const buf = new Buffer(params.data.replace(/^data:image\/\w+;base64,/, ''),'base64');
  const payload = {
    ACL: 'public-read',
    Body: buf,
    Bucket: params.config.bucket,
    ContentType: 'image/png',
    ContentEncoding: 'base64',
    // ContentDisposition: 'inline; filename="' + fileName + '"',
    Key: `${params.config.path}/${fileName}`
  };

  let upload = s3.upload(payload);
  upload.send((error, data) => {
    if (data) {
      callback(true, {data});
    }
    else {
      callback(false, {data});
    }
  });
};

export const uploadMultiSignatureToS3 = (params, callback) => {
  config.credentials = new Credentials({
    accessKeyId: params.config.accessKeyId,
    secretAccessKey: params.config.secretAccessKey,
    sessionToken: params.config.sessionToken
  });

  const s3 = new S3({ region: params.config.region });

  let uploadPromises = params.data.map(item => {
    if (!item.signatureUrl && item.signatureData) {
      let fileName = uuidv4() + '.png';
      let buffer = new Buffer(item.signatureData.replace(/^data:image\/\w+;base64,/, ''),'base64');
      let payload = {
        ACL: 'public-read',
        Body: buffer,
        Bucket: params.config.bucket,
        ContentType: 'image/png',
        ContentEncoding: 'base64',
        Key: `${params.config.path}/${fileName}`
      };

      return s3.upload(payload).promise();
    }

    return Promise.resolve(item.signatureUrl);
  });

  let finalPromise = Promise.all(uploadPromises);

  finalPromise.then(
    responses => {
      let result = responses.map(data => {
        if (!data || data.constructor === String) {
          return data;
        }
        else {
          return data.Location;
        }
      });

      callback(true, result);
    },
    errors => {
      callback(false, errors);
    }
  );
};



// WEBPACK FOOTER //
// ./src/Common/api.js